"use client";
import s from "./ShareButton.module.scss";
import { IconImage } from "@/components/UI/IconImage";
import { useEffect, useRef, useState } from "react";
import cn from "classnames";
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from "react-share";
import { usePathname } from "next/navigation";
import { baseUrl } from "@/const";
import { SpriteIcon } from "@/components/UI/SpriteIcon";
import FacebookIcon from "public/img/icons/svg/facebook-alt.svg";
import LinkedinIcon from "public/img/icons/svg/linkedin-alt.svg";
import TwitterIcon from "public/img/icons/svg/twitter.svg";

type ShareButtonProps = {
  className?: string;
};

export const ShareButton = ({ className }: ShareButtonProps) => {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();

  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const checkClickOutside = (event: MouseEvent) => {
      // @ts-ignore
      const closestContainer = event.target.closest(".js-share");

      if (!closestContainer || closestContainer !== wrapperRef.current) {
        setOpen(false);
      }
    };

    document.addEventListener("click", checkClickOutside);

    return () => {
      document.removeEventListener("click", checkClickOutside);
    };
  }, []);

  return (
    <div
      className={cn(
        "js-share",
        s.wrapper,
        {
          [s.open]: open,
        },
        className
      )}
      ref={wrapperRef}
    >
      <div className={s.inner}>
        <div className={s.buttons}>
          <FacebookShareButton
            onClick={() => setOpen(false)}
            url={`https://${baseUrl + pathname}`}
            className={s.shareBtn}
          >
            <SpriteIcon icon={FacebookIcon} />
          </FacebookShareButton>
          <TwitterShareButton
            onClick={() => setOpen(false)}
            url={`https://${baseUrl + pathname}`}
            className={s.shareBtn}
          >
            <SpriteIcon icon={TwitterIcon} />
          </TwitterShareButton>
          <LinkedinShareButton
            onClick={() => setOpen(false)}
            url={`https://${baseUrl + pathname}`}
            className={s.shareBtn}
          >
            <SpriteIcon icon={LinkedinIcon} />
          </LinkedinShareButton>
        </div>

        <button type="button" className={s.button} onClick={() => setOpen(!open)}>
          <IconImage size={24} icon="share" />
        </button>
      </div>
    </div>
  );
};
